export function shouldBlockScoreRegisterAccess(
  isScoreProgram: boolean,
  hasAnyOnlineRegistration: boolean,
): boolean {
  return isScoreProgram && !hasAnyOnlineRegistration;
}

export function canAccessScoreStudyMaterials(
  isScoreProgram: boolean,
  hasAnyOnlineRegistration: boolean,
): boolean {
  return isScoreProgram && hasAnyOnlineRegistration;
}

export function isScoreGatedTestRouteKey(routeKey: string): boolean {
  return routeKey === "MCTS" || routeKey === "PYPS";
}
